/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IAppointments } from 'app/shared/model/appointments.model';
import { IAppointmentStatus } from 'app/shared/model/appointment-status.model';

export interface IAppointmentHistory {
  id?: string;
  createdDtm?: number | null;
  createdBy?: string | null;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  active?: boolean;
  cursor?: number;
  appointment?: IAppointments;
  status?: IAppointmentStatus;
}

export const defaultValue: Readonly<IAppointmentHistory> = {
  active: false,
};
